var Backbone = require('backbone');
var _ = require('lodash');
var $ = require('jquery');
var template = require('../templates/thanks.ejs');
var PubSub = require('tscom-pubsub');

module.exports = Backbone.View.extend({
    tagName: 'div'
    , className: 'view-thanks'
    , events: {
        'click .facebook': 'routeFacebook',
        'click .twitter': 'routeTwitter',
        'click .google': 'routeGoogle',
        'click .btn-vote-again': 'close'
    }
    /**
   *
   */
    , initialize: function (options) {
        _.bindAll(this, 'render');

        try {
            if(_.isUndefined(options.controller)){
                throw Error('The controller is a dependency. Please inject the controller into the view.');
            }
        } catch (e) {
            console.log(e);
        }

        this.controller = options.controller;
        this.voteOption = this.controller.Collections.VoteOption.getSelected().toJSON();
        this.selectedModel = this.controller.Collections.VoteOption.getSelected();
    }
    /**
   *
   */
    , render: function () {
        var scope = {};
        var model = this.voteOption;

        var text = this.controller.Models.Cms.get('text')['views_vote_confirmation'];
        var design = this.controller.Models.Cms.get('text')['design'];
        var cms = this.controller.Models.Cms.get('social');
        var twShare = this.controller.Models.Cms.get('text')['views_share'].twitter_copy;
        var googlePlus = cms.fb.share.link;
        var shareSettings = this.controller.Models.Cms.get('text')['views_share'];

        //Parse through twitter share for first name and last name
        var firstName = model.firstname;
        var lastName = model.lastname;
        twShare = twShare.replace('{firstname}', firstName);
        twShare = twShare.replace('{lastname}',lastName);

        var contestant = lastName != '' ? firstName+' '+lastName : firstName;
        var twVoteText = text.twitter_vote.tweet_copy.replace('{contestant}',contestant);

        //Build Twitter share link and info
        var twShareUrl = encodeURIComponent(twShare);
        var twVoteTextUrl = encodeURIComponent(twVoteText);

        scope.twShareUrl = twShareUrl;
        scope.twitterVoteText = twVoteTextUrl;

        //Add CMS data to the scope object
        scope.google = googlePlus;
        scope.text = text;
        scope.design = design;
        scope.shareSettings = shareSettings;

        _.extend(scope, model);

        console.log('extended scope: ', scope);

        this.$el.html(template(scope));

        return this;
    }
    /**
   *
   */
    , routeGoogle: function (e) {
        e.preventDefault();
        this.controller.trackEvent(e, 'eventShareGooglePlus');
    }
    /**
   *
   */
    , routeFacebook: function (e) {
        e.preventDefault();

        var shareURL = this.buildFacebookShareURL();

        this.controller.Models.Facebook.share(shareURL);
        this.controller.trackEvent(e, 'eventShareFacebook');
    }
    /**
   *
   */
    , buildFacebookShareURL: function() {
        var data = this.controller.Models.Cms.get('social').fb.share;

        var fullName = this.voteOption.firstname + ' ' + this.voteOption.lastname;

        data.description = data.description.replace('<<CONTESTANT>>', fullName);

        var params = {
            name: data.name
            ,description: data.description
            ,image: this.voteOption.image
            ,caption: data.caption
            ,link: data.link
            ,href: data.link
            ,appId: this.controller.Models.Facebook.get('appId')
            ,display: 'popup'
            ,redirect_uri: data.redirect_uri
        };

        var url = window.location.href.split('?')[0];
        url = url+'share/?'+$.param(params);

        return url;
    },
    /**
   *
   */
    routeTwitter: function (e) {
        this.controller.trackEvent(e, 'eventShareTwitter');
    },

    voteAgain: function(e){

        e.preventDefault();
        this.trigger('voteagain',this.selectedModel);
    },
    /**
   *
   */
    close: function() {
        PubSub.trigger('close-modal');
    }
});




//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/views/thanks.js
// module id = 261
// module chunks = 0